import React from 'react';
import { TrainingShell } from '../components/TrainingV2';

const DataGovernanceTraining: React.FC = () => {
  return (
    <TrainingShell
      moduleId="understanding-data-governance"
      moduleName="Understanding Data Governance"
      backUrl="/learn101"
    />
  );
};

export default DataGovernanceTraining;
